import { ArgsType, Field, Int } from '@nestjs/graphql'
import { BaseGetArgs } from '../base/baseGet.args'

@ArgsType()
export class ArcGetArgs extends BaseGetArgs<ArcGetArgs> {
  @Field(type => String, { defaultValue: ''})
  needle: string = ''

  @Field(t => Boolean, { nullable: true })
  activeOnly?: boolean

  @Field(t => Boolean, { nullable: true })
  scheduledOnly?: boolean

  @Field(t => Boolean, { nullable: true })
  finishedOnly?: boolean

  @Field(t => Boolean, { nullable: true })
  draftOnly?: boolean

  @Field(t => Int, { nullable: true })
  arcType?: number

  @Field(t => Boolean, { nullable: true })
  withNewReviewActivityStatus?: boolean
}
